import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'environments/environment';

@Pipe({
    name: 'getS3ImageSrc'
})
export class GetS3ImageSrcPipe implements PipeTransform {
    transform(model: any): any {
        if (typeof model === 'string') {
            return environment.s3Url + model + '/';
        }
        if (model && model.file_md5_name) {
            return environment.s3Url + model.model_name + '/' + model.model_id + '/' + model.file_md5_name;
        } else {
            return environment.appUrl + 'assets/images/placeholder-image.png'
        }
    }
}
